import TextInput from '../TextInput';
import TaggableInput from '../TaggableInput.jsx';

const SlackSettings = ({ settings, setSettings, schema }) => {
    return (
        <div>
            <div className="text-sm text-gray-600 mb-4">
                Send a message to a Slack channel using a webhook URL
            </div>
            <TextInput
                label="Webhook URL"
                type="url"
                inputClassName="w-full max-w-full border-none rounded-lg"
                placeholder="https://hooks.slack.com/services/..."
                value={settings?.webhook_url || ''}
                onChange={value => setSettings({ ...settings, webhook_url: value })}
            />
            <div className="text-xs text-gray-500 mt-1 ml-4">
                Get this URL from your Slack app's <a href="https://api.slack.com/messaging/webhooks#getting_started" rel="noopener noreferrer" target="_blank">Incoming Webhooks</a> settings
            </div>

            <div className="input-label mt-6">Message</div>
            <TaggableInput
                schema={schema}
                className="min-h-20"
                initialValue={settings?.slack_message || ''}
                onChange={value => setSettings({ ...settings, slack_message: value })}
                placeholder="Enter your message here..."
            />
        </div>
    );
};

export default SlackSettings;
